import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronDown, HelpCircle } from "lucide-react";

const FAQS = [
  {
    q: "How far in advance should I order?",
    a: "For custom pre-order cakes, the sooner the better — popular dates book up fast. Same-day cakes need at least 2 hours notice, and anything under 6 hours notice has a $50 rush fee. Next-day orders must be placed before 6 PM.",
  },
  {
    q: "What's the difference between same-day, next-day and pre-order?",
    a: "Same-day and next-day are quick pickup cakes (6\" round or heart solid cakes only). Pre-order unlocks the full Sugar Collection with a calendar so you can pick any available date.",
  },
  {
    q: "Do you deliver?",
    a: "Same-day and next-day cakes are always pickup only. Delivery is available on pre-orders only — and it's free in Langley & Surrey, and free on all orders over $200. Other areas have a small delivery fee shown at checkout. Pickup is always free.",
  },
  {
    q: "What flavours do you offer?",
    a: "A rotating range of cake and buttercream flavours — you'll choose yours right inside each cake's order form. Cupcake bouquets are vanilla only, as it's a special recipe that holds the flower shapes.",
  },
  {
    q: "Can you make my cake match an inspo photo?",
    a: "Absolutely. Most forms let you upload an inspiration photo, and the notes box is the perfect place to describe exactly what you're after. If your inspo has butterflies, sparkles or bows, please add them as paid add-ons so I can include them.",
  },
  {
    q: "Do you accommodate allergies?",
    a: "Please tell me about any allergies in the order notes or via Contact Me before ordering. My kitchen handles nuts, dairy, gluten and eggs, so I can't guarantee a fully allergen-free environment, but I'll always do my best.",
  },
  {
    q: "How do payments and deposits work?",
    a: "Standard cakes are paid securely by card at checkout. Wedding cakes are quoted individually — after our consultation you'll receive a contract and an invoice. Taxes apply to all orders.",
  },
  {
    q: "Can I track my order?",
    a: "Yes — once you've ordered, head to the Track tab to follow your cake from received, confirmed, preparing, on route, to delivered.",
  },
];

export default function FAQ() {
  const navigate = useNavigate();
  return (
    <div className="App bg-sugar-bg">
      <Navbar />
      <section className="sugar-hero-bg px-5 pb-8 pt-8">
        <span className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.28em] text-sugar-ink2"><HelpCircle size={13} className="text-sugar-rose" /> Good to know</span>
        <h1 className="mt-3 font-display text-[2.4rem] font-semibold leading-tight text-sugar-ink">Frequently asked <span className="italic font-normal text-sugar-rose">questions</span></h1>
        <p className="mt-3 text-[15px] leading-relaxed text-sugar-ink2">Everything you need to know before placing your order. Still have a question? Reach out anytime.</p>
      </section>

      <section className="px-5 py-6">
        <div className="space-y-3">
          {FAQS.map((item, i) => (
            <details key={i} data-testid={`faq-item-${i}`} className="group rounded-2xl border border-sugar-border bg-white p-5 [&_summary::-webkit-details-marker]:hidden">
              <summary className="flex cursor-pointer list-none items-center justify-between gap-3">
                <span className="font-display text-base font-bold text-sugar-ink">{item.q}</span>
                <ChevronDown size={18} className="shrink-0 text-sugar-pink transition-transform group-open:rotate-180" />
              </summary>
              <p className="mt-3 text-sm leading-relaxed text-sugar-ink2">{item.a}</p>
            </details>
          ))}
        </div>
        <Button data-testid="faq-contact-btn" onClick={() => navigate("/contact")} variant="outline" className="mt-7 w-full rounded-full border-sugar-ink py-6 text-xs font-bold uppercase tracking-[0.18em] text-sugar-ink hover:bg-sugar-ink hover:text-sugar-bg">
          Still have a question? Contact me
        </Button>
      </section>

      <Footer />
    </div>
  );
}
